module.exports = __webpack_public_path__ + "media/images/av-logo-horizontal-4a9161aaa63e7e5e1112e67ec25eda23.svg";